/**
 * Utility functions for frontend
 */

/**
 * Combines class names, filtering out falsy values.
 * Similar to clsx/classnames but simpler.
 *
 * @example
 * cn('base', isActive && 'active', disabled && 'disabled')
 * // Returns 'base active' if isActive is true and disabled is false
 */
export function cn(...inputs: (string | undefined | null | false)[]): string {
  return inputs.filter(Boolean).join(' ');
}
